// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LOGOUT = "Odhl\u00e1s sa";
